import React from "react";
export function Dashboard() {
  return <></>;
}
